import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { BaseService } from '../shared-service/base.service';
import { DeeplinkService } from './deeplink.service';
import { LoginService } from '../login/login.service'
import { APP_CONFIG, AppConfig } from '../shared-service/app.config';
import { Location } from '@angular/common';

import { DataService } from '../shared-service/data.service';
import { Title } from '@angular/platform-browser';
import { DeepLinkRouteData } from './deeplink-route-data';

declare var $: any;
declare var sessionStorage: any;

@Component({
    selector: 'app-login',
    templateUrl: './deeplink.component.html',
    styleUrls: ['./deeplink.component.css']
})
export class DeeplinkComponent implements OnInit {

    UserAccountDetail: Object | any = {};
    LearningItemDetail: Object | any = {};

    error: Object|any = {};

    constructor(public bs: BaseService, private loginService: LoginService, private ds: DataService, private titleService: Title, private deeplinkService: DeeplinkService, private router: Router, private route: ActivatedRoute, @Inject(APP_CONFIG) private config: AppConfig,
        private location: Location) {
        this.bs.log('info', "DeeplinkComponent Loaded");
        this.error['err'] = false;
        this.bs.log('info', this.bs.config["apiEndpoint"]);
    }

    ngOnInit() {
        let params = {
            "DeeplinkUrl": sessionStorage.getItem('switchAdminToLearnerUrl') //location.href
        };
       
        if (
            this.getParameterByName("redirect_fragment", window.location.href) &&
            this.getParameterByName("metadata", window.location.href)
        ) {
            params["DeeplinkUrl"] = location.origin + '/#/' + 'deeplink' + '?metadata='+this.getParameterByName("metadata", window.location.href)
        }

        sessionStorage.removeItem('switchAdminToLearnerUrl');

        this.deeplinkService.getDeeplinkDetailFromServer(params, this.config.storageResourcesKey).then((res:any) => { 
            this.LearningItemDetail = res["LearningItemDetail"];           
            if (this.LearningItemDetail["CanAccess"] == false) {
                alert(this.LearningItemDetail["ValidationMessage"]);
                return;
            }
            if (this.LearningItemDetail["IsValidUser"] == false) {
                alert(this.LearningItemDetail["ValidationMessage"]);
                return;
            }
            this.UserAccountDetail = res["UserAccountClass"];               
            this.setUserAttributesInSessionStorage(this.UserAccountDetail);
            sessionStorage.setItem("user", JSON.stringify(this.UserAccountDetail));
            this.bs.loadUserAccount(this.UserAccountDetail);
            this.bs.setUserAtibuteLoded(true);
            this.bs.userProfileImage = this.bs.getUserAttr("UserImage");
            this.bs.isActiveNotification = this.bs.getUserAttr("isActiveNotification");
            this.titleService.setTitle(this.bs.getUserAttr('ProductTitle'));
            if (this.bs.isActiveNotification) {
                this.bs.NotificationClass = "active";
                this.bs.AnnouncementClass = "";
            }
            else {
                this.bs.NotificationClass = "";
                this.bs.AnnouncementClass = "active";
            }
            this.ds.setStoreData(this.config.storageLoginKey, JSON.parse(sessionStorage.getItem("user")));
            const sResource = { "CorporateId": this.UserAccountDetail['CorporateId'], "Culture": this.UserAccountDetail['Culture'] };
            this.loginService.getStringResourceFromServer(sResource, this.config.storageResourcesKey).then((res) => {
                sessionStorage.setItem("resource", JSON.stringify(res));
                this.ds.setStoreData(this.config.storageResourcesKey, JSON.parse(sessionStorage.getItem("resource")));
                this.bs.loadStringResources(res);
                this.navigateUserToContent();
            }, (res) => {
                console.log(res);
            });
        }, (res) => {

        });
    }

    navigateUserToContent() {
        let params:any = {
            tab: '',
            id: this.LearningItemDetail["LearningItemId"]
        }

        let deepLinkRouteData: DeepLinkRouteData;

        var learningType = this.LearningItemDetail["LearningItemType"];
        var isPublicLearning = this.LearningItemDetail["IsPublicLearning"];
        var isExpired = this.LearningItemDetail["IsLearningItemExpired"];
        // 1 => Course, 2 => Program, 3 => ILT, 4 => Video, 5 => Announcement, 6 => Conversation, 7 => Survey
        switch (learningType) {
            case 2: //Program
            case 1: //Course
                this.bs.isResumeClicked = false;
                params['CourseLaunchId'] = '';
                params['IsNodeClick'] = false;
                this.bs.menuKey = "rbkey_LrnLBL";
                this.bs.isVwLrng = false;
                this.bs.isTrainingHistory = false;
                if (isExpired == true) {
                    this.bs.isTrainingHistory = true;                    
                    this.bs.submenuKey = "rbkey_TrnngHstryLBL";
                    deepLinkRouteData = this.deeplinkService.PrepareDeepLinkData("tsk_mdl", "crs_dtl", "rbkey_LrnLBL", "rbkey_TrnngHstryLBL");
                }
                else if (isPublicLearning == false) {
                    this.bs.submenuKey = "rbkey_MyLrnngLBL";
                    deepLinkRouteData = this.deeplinkService.PrepareDeepLinkData("tsk_mdl", "crs_dtl", "rbkey_LrnLBL", "rbkey_MyLrnngLBL");
                }
                else {
                    this.bs.submenuKey = "rbkey_MyLrnngLBL";
                    // deepLinkRouteData = this.deeplinkService.PrepareDeepLinkData("crs_ctlg_mdl", "ctlg_dtl", "rbkey_LrnLBL", "rbkey_CtlgLBL");
                    deepLinkRouteData = this.deeplinkService.PrepareDeepLinkData("tsk_mdl", "ctlg_dtl", "rbkey_LrnLBL", "rbkey_MyLrnngLBL");
                }
                this.deeplinkService.SetDeepLinkNavigationData(deepLinkRouteData);
                this.routeTo(this.bs.getFullPath(deepLinkRouteData.MappedRoute), params);
                break;
            // case "PRG":

            //     break;
            case 3: //ILT
                this.bs.routerParam['ILT_DETAIL'] = params;
                this.bs.menuKey = "rbkey_LrnLBL";           
                this.bs.submenuKey = "rbkey_MyLrnngLBL";
                if (isPublicLearning == false) {    
                    deepLinkRouteData = this.deeplinkService.PrepareDeepLinkData("tsk_mdl", "ilt_dtl", "rbkey_LrnLBL", "rbkey_MyLrnngLBL");
                }
                else {
                    params['cns'] = "Open";
                    // deepLinkRouteData = this.deeplinkService.PrepareDeepLinkData("tsk_mdl", "ctlg_ilt_dtl", "rbkey_LrnLBL", "rbkey_CtlgLBL");
                    deepLinkRouteData = this.deeplinkService.PrepareDeepLinkData("tsk_mdl", "ctlg_ilt_dtl", "rbkey_LrnLBL", "rbkey_MyLrnngLBL");
                }

                this.deeplinkService.SetDeepLinkNavigationData(deepLinkRouteData);
                this.routeTo(this.bs.getFullPath(deepLinkRouteData.MappedRoute), params);
                break;
            case 4: //Video
                
                this.bs.menuKey = "rbkey_LrnLBL";           
                this.bs.submenuKey = "rbkey_MyLrnngLBL";
                deepLinkRouteData = this.deeplinkService.PrepareDeepLinkData("vd_mdl", "ilt_dtl", "rbkey_LrnLBL", "rbkey_MyLrnngLBL");

                //If we redirect from History Video  
                setTimeout(() => {                   

                    params["videoid"] = this.LearningItemDetail['LearningItemId'];
                    params["channelId"] = null;
                    params["date"] = new Date().getTime();
                    this.deeplinkService.SetDeepLinkNavigationData(deepLinkRouteData);

                    this.router.navigateByUrl("/learner/video-library/container/(home//videoPlayer:videoPlayer;videoid=" + this.LearningItemDetail['LearningItemId'] + ";channelId=null;date=" + new Date().getTime() + ")");

                }, 500);
                break;
            case 5: //Announcement

                params["AnnoncementId"] = this.LearningItemDetail['LearningItemId'];
                params["UserID"] = this.LearningItemDetail['UserId'];
                params["CorporateID"] = this.LearningItemDetail['CorporateId'];

                params["IsAnnouncement"] = true;
                params["RefreshParam"] = new Date();
                
                this.router.navigateByUrl("/learner/system-alert/announcement;IsAnnouncement=true;RefreshParam=" + new Date().getTime() + "/(Alert:announcement-list)");

                break;
            case 6: //Conversation            
                this.bs.menuKey = "rbkey_CllbrtLBL";           
                this.bs.submenuKey = "rbkey_CnvrstnLBL";
                deepLinkRouteData = this.deeplinkService.PrepareDeepLinkData("cnvrstn_mdl", "", "rbkey_CllbrtLBL", "rbkey_CnvrstnLBL");
                this.deeplinkService.SetDeepLinkNavigationData(deepLinkRouteData);
                this.routeTo(this.bs.getCurrentModulePath(), params);

                break;
            case 7: //Survey    
                this.bs.menuKey = "rbkey_CllbrtLBL";           
                this.bs.submenuKey = "rbkey_SrvyLBL";
                deepLinkRouteData = this.deeplinkService.PrepareDeepLinkData("srvy_mdl", "", "rbkey_CllbrtLBL", "rbkey_SrvyLBL");
                this.deeplinkService.SetDeepLinkNavigationData(deepLinkRouteData);
                this.routeTo(this.bs.getCurrentModulePath(), params);
                break;

        }


    }

    routeTo(path: string, params: object) {
        this.router.navigate([path, params]).then((res) => {
            console.log(res);
        });
    }

    validateLogin(uId:any, pwd:any) {
        const body = { "userName": uId, "password": pwd, "IPAddress": "000.00.0.0", "deviceUUID": "", "corporateID": this.LearningItemDetail["CorporateId"] };

        this.deeplinkService.getLoginDetailFromServer(body, this.config.storageLoginKey, "freshLogin").then((res:any) => {
            
            sessionStorage.setItem("user", JSON.stringify(res));
            this.bs.loadUserAccount(res);
            this.bs.setUserAtibuteLoded(true);
            this.setUserAttributesInSessionStorage(res);

            this.bs.userProfileImage = this.bs.getUserAttr("UserImage");
            this.bs.isActiveNotification = this.bs.getUserAttr("isActiveNotification");
            this.titleService.setTitle(this.bs.getUserAttr('ProductTitle'));
            if (this.bs.isActiveNotification) {
                this.bs.NotificationClass = "active";
                this.bs.AnnouncementClass = "";
            }
            else {
                this.bs.NotificationClass = "";
                this.bs.AnnouncementClass = "active";
            }

            this.ds.setStoreData(this.config.storageLoginKey, JSON.parse(sessionStorage.getItem("user")));


            const sResource = { "CorporateId": res['CorporateId'], "Culture": res['Culture'] };
            this.loginService.getStringResourceFromServer(sResource, this.config.storageResourcesKey).then((resrec) => {
                
                sessionStorage.setItem("resource", JSON.stringify(resrec));
                this.ds.setStoreData(this.config.storageResourcesKey, JSON.parse(sessionStorage.getItem("resource")));

                this.bs.loadStringResources(resrec);

                let params = {
                    "CorporateId": res['CorporateId'],
                    "LearningItemId": this.LearningItemDetail["LearningItemId"],
                    "LearningItemType": this.LearningItemDetail["LearningItemType"],
                    "IsPubliclySharableLink": this.LearningItemDetail["IsPubliclySharableLink"],
                    "UserId": res['UserId']
                };

                this.deeplinkService.GetLearningItemDetail(params, "****").then((learningres:any) => {
                    
                    if (learningres["CanAccess"] == false) {
                        alert(this.bs.getResource('rbkey_DplnkNtAccssblMsg'));
                        return;
                    }   
                    this.LearningItemDetail = learningres;                 
                    this.navigateUserToContent();
                }, (res) => {  });



            }, (res) => {

            });
        }, (res) => {

        });
    };


    setUserAttributesInSessionStorage(UserAccountDetail : any)
    {        
        let userRoles = UserAccountDetail["UserRoles"];
        let selectedRole = userRoles.filter((x:any)=>x["mstrRoleType"] == "L")[0]["mnUserRoleId"]

         sessionStorage.setItem("selectedUserRoleID", selectedRole);
         sessionStorage.setItem("selectedCulture", UserAccountDetail["Culture"]);

    }

    private  getParameterByName(name:any, url = window.location.href) {

		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	};

}
